import React, { useState, useEffect, Fragment, useMemo, useCallback, useRef } from "react";
import {
  Row,
  Card,
  Col,
  Label,
  Input,
  Table,
  UncontrolledTooltip,
  Alert
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import { createSelector } from "reselect";
import StyledPagination from "../../../components/Common/StyledPagination.jsx";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import Spinners from "../../../components/Common/Spinner";
import { useFormik } from "formik";
import AlertError from "../../../components/Alerts/AlertError";
import Select from "react-select";
import * as XLSX from "xlsx";
import {
  getOrgsAdmin as onGetOrgsAdmin,
  getEmployeesAdmin,
  postEmployeesAdminCreateAddress,
  postServicesAdmin,
  putPlatformRequest,
  getServiceRequestAdmin,
  patchUpdateRequest
} from "../../../helpers/api_rombo_helper";
import PlacesServices from "../../Google/PlacesServices";
import Places from "../../Google/Places/index.jsx";
import MapServices from "../../Google/MapServices";
import { map, chunk, debounce } from "lodash";
import config from "../../../constants/settings";
import { BookingType, VisibilityTypes, TypeAddress, EmployeeStatus } from "../../../constants/enums";
import EmployeeScalePopup from "../../../components/Popups/EmployeeScalePopup.jsx";
import { orgId, isPartnerAllowed } from "../../../constants/utils";
import * as Yup from "yup";


const isTripInProgress = (service) =>
  Boolean(service?.trip?.started_at) && !service?.trip?.ended_at;

const ROUTE_EDIT_ERRORS = {
  STOP_HAS_BOARDED_RIDERS: "RouteEditStopHasBoardedRiders",
  STOP_ALREADY_VISITED: "RouteEditStopAlreadyVisited",
};

const routeEditErrorMessage = (error) => {
  const body = error?.response?.data?.error?.message;
  const key = ROUTE_EDIT_ERRORS[body?.code];
  if (!key) return null;
  return `${i18n.t(key)} (${body.detail})`;
};

const RequestService = (props) => {
  document.title = `${i18n.t("ServiceRequest")} - ${orgId}`;

  const dispatch = useDispatch();
  const history = useNavigate();
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [listCompanies, setListCompanies] = useState([]);
  const [minTime, setMinTime] = useState("");
  const [key, setKey] = useState(0);
  const [isFirstCompanySelection, setIsFirstCompanySelection] = useState(true);
  const [listTypeService, setListTypeService] = useState([]);
  const [company, setCompany] = useState({});
  const [typeService, setTypeService] = useState({ label: i18n.t("TextService2"), value: BookingType.CLOSED });
  const [showCompany, setShowCompany] = useState(true);
  const [showGeneral, setShowGeneral] = useState(false);
  const [showDateHour, setShowDateHour] = useState(false);
  const [showTypeService, setShowTypeService] = useState(false);
  const [showAdditionalNote, setShowAdditionalNote] = useState(false);
  const [showAddresses, setShowAddresses] = useState(false);
  const [showUnits, setShowUnits] = useState(false);
  const [showIdTag, setShowIdTag] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [showEmployeesAvailable, setShowEmployeesAvailable] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showScales, setShowScales] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [buttonSearch1, setButtonSearch1] = useState(true);
  const [buttonSearch2, setButtonSearch2] = useState(true);
  const [onFocusAddress, setOnFocusAddress] = useState("");
  const [newCreateAddressEmployee, setNewCreateAddressEmployee] = useState({});
  const [filterName, setFilterName] = useState(null);
  const [filterName2, setFilterName2] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [formatEmployees, setFormatEmployees] = useState([]);
  const [messageValidAddress, setMessageValidAddress] = useState("");
  const [checkFileEmpllyee, setCheckFileEmployee] = useState(false);
  const [selectFile, setSelectFile] = useState(false);
  const [arrScales, setArrScales] = useState([{ id: 3, latLon: false, typeAddress: TypeAddress.ARRAY_SCALES, dragg: false, editRow: false, onDrag: false, passenger_id: null, name: null, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);
  const [opts, setOpts] = useState({});
  const [aditionalNote, setAditionalNote] = useState("");
  const [idTag, setIdTag] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedServiceOption, setSelectedServiceOption] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const [showNextBlock, setShowNextBlock] = useState(false);
  const [disableTextarea, setDisableTextarea] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestiny, setSelectedDestiny] = useState(null);
  const [originAddressService, setOriginAddressService] = useState({});
  const [destinyAddressService, setDestinyAddressService] = useState({});
  const [addressesMarkers, setAddressesMarkers] = useState([]);
  const [units, setUnits] = useState(1);
  const [showUnitSelect, setShowUnitSelect] = useState(false);
  const [selectedUnitOption, setSelectedUnitOption] = useState(null);
  const [titleAdressDestiny, setNameTitleDestiny] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: "" }));
  const [titleAdressOrigin, setNameTitleOrigin] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: "" }));
  const [titleAdressArrScales, setNameTitleArrScales] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Employee"), address: "" }));
  const [titleAdressArrEmployees, setNameTitleEmployees] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Scale"), address: "" }));
  const [employees, setEmployees] = useState([]);
  const [employeeAddress, setEmployeeAddress] = useState(null);
  const [showAddEmployeeLink, setShowAddEmployeeLink] = useState(true);
  const [employeesSelectedFind, setEmployeesSelectedFind] = useState([]);
  const [employeesSelected, setEmployeesSelected] = useState([]);
  const [findEmployees, setFindEmployees] = useState([]);
  const [visibleTables, setVisibleTables] = useState({});
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [editingEmployees, setEditingEmployees] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [validationsAddresses, setValidationsAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [temporarySelections, setTemporarySelections] = useState({});
  const [showAddEmployeeForm, setShowAddEmployeeForm] = useState(false);
  const [editingAddressForEmployee, setEditingAddressForEmployee] = useState({});
  const [newAddress, setNewAddress] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [tempAddress, setTempAddress] = useState({});
  const [unregisteredEmployee, setUnregisteredEmployee] = useState({ name: "", depot: "" });
  const [serviceCode, setServiceCode] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [autoAddedEmployeeId, setAutoAddedEmployeeId] = useState(null);
  const [hasEmployeeScale, setHasEmployeeScale] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [showScaleModal, setShowScaleModal] = useState(false);
  const [pendingEmployee, setPendingEmployee] = useState(null);
  const [pendingIsAutomaticSelection, setPendingIsAutomaticSelection] = useState(false);
  const [pendingIsSingleUnitForMe, setPendingIsSingleUnitForMe] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [errors, setErrors] = useState({
    origin: false,
    destiny: false,
    company: false,
    date: false,
    hour: false,
    typeService: false,
  });

  const [dateService, setDateService] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  });

  const [hourService, setHourService] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 25);
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  const userProfile = {
    username: data?.data?.full_name || '',
    sub: data?.data?.id || ''
  };

  const setError = (field, value) => {
    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: value,
    }));
  };

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: "",
      identifier: "",
      depot: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string(),
      identifier: Yup.string(),
      depot: Yup.string()
    })
  });

  useEffect(() => {
    fillTypeService()
    getMinutes()
    infoUser.is_staff ? getCompanies() : fillCompany();
  }, [dispatch, infoUser]);
  
  useEffect(() => {
    if (company?.value !== undefined) {
      onGetEmployeesAdmin();
    }
  }, [dispatch, company]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    fEmployee();
  }, [employeesSelected]);

  useEffect(() => {
    if (editingEmployee?.addresses?.length > 0) {
      setSelectedAddress(editingEmployee.addresses[0].id);
    }
  }, [editingEmployee]);

  useEffect(() => {
    const now = new Date();
    const today = new Date();
  
    const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    
    if (dateService === todayStr) {
      now.setMinutes(now.getMinutes() + 25);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      
      setMinTime(minTimeFormatted);
  
      const [currentHour, currentMinute] = hourService.split(':').map(Number);
      const minTimeInMinutes = parseInt(minHours) * 60 + parseInt(minMinutes);
      const currentTimeInMinutes = currentHour * 60 + currentMinute;
      
      if (currentTimeInMinutes < minTimeInMinutes) {
        setHourService(minTimeFormatted);
      }
    } else {
      setMinTime("");
    }
  }, [dateService, hourService]);  

  useEffect(() => {
    fillTypeService();
  }, []);
  
  useEffect(() => {
    fillTypeService();
    setTypeService(prev => ({
      ...prev,
      label: i18n.t("TextService2")
    }));
  }, [i18n]);

  useEffect(() => {
    validateAddresses();
  }, [originAddressService.description, destinyAddressService.description, typeService.value]);

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);  

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);

  const fEmployee = () => {
    let arr = []
    employeesSelected.map((item) => {
      arr.push({ label: item.name, value: item.idEmployee })
    })
    setFormatEmployees([...arr])
  }

  const searchFilters = debounce((value, type) => {
    setFindEmployees([]);
  
    let newOpts = {
      ...autoformik.values,
      [type]: value,
      partner_id: company.value,
      page: 1,
      size: 5,
    };
  
    Object.keys(newOpts).forEach(
      (key) => (newOpts[key] === "" || newOpts[key] === null) && delete newOpts[key]
    );
  
    onGetEmployeesAdmin(newOpts);
  }, 300);

  const getMinutes = (selectedDate) => {
    const minTimeSlots = parseInt(config.services.timeSlots, 10) + 5;
    const now = new Date();
    const date = new Date(selectedDate);
  
    if (isNaN(date.getTime())) {
      console.error('Fecha seleccionada inválida');
      return;
    }
  
    const isToday = now.toDateString() === date.toDateString();
  
    if (isToday) {
      now.setMinutes(now.getMinutes() + minTimeSlots);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      setMinTime(minTimeFormatted);
      setHourService(minTimeFormatted);
    } else {
      setMinTime("00:00");
      setHourService("00:00");
    }
  };  

  useEffect(() => {
    if(!newCreateAddressEmployee.idDB) return;

    let body = { addresses: [{ name: "Default", address: { ...newCreateAddressEmployee } }]}
    postEmployeesAdminCreateAddress(token, newCreateAddressEmployee.idDB, body)
      .then((responseAddress) => {
        onGetEmployeesAdmin()
      })
      .catch((error) => { 
        console.error("Error - postEmployeesAdminCreateAddress - ", error)
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
      })  
    
  }, [newCreateAddressEmployee]);

  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const isInProgress = isEditMode && isTripInProgress(currentService);
  
  useEffect(() => {
    if (id && token?.Authorization) {
      setIsEditMode(true);
      fetchServiceRequest(id);
    }
  }, [id, token?.Authorization]);

  useEffect(() => {
    if (isEditMode) {
      setShowNextBlock(true);
    }
  }, [isEditMode]);
  
  useEffect(() => {
    if (showEmployees && isEditMode && company.value) {
      const initialOpts = { 
        partner_id: company.value, 
        size: 5, 
        status: EmployeeStatus.ACTIVE,
        page: 1
      };
      onGetEmployeesAdmin(initialOpts);
      
      if (employeesSelectedFind.length > 0) {
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        setFindEmployees(prev => prev.filter(emp => !selectedIds.includes(emp.id)));
      }
    }
  }, [showEmployees, isEditMode, company.value, employeesSelectedFind]);
  
  const fetchServiceRequest = async (requestId) => {
    try {
      const response = await getServiceRequestAdmin(token, requestId);
      const data = response || {};
      setCurrentService(data);
  
      setTypeService({
        label:
          data.type === BookingType.OPEN
            ? i18n.t("TextService1")
            : data.type === BookingType.CLOSED
            ? i18n.t("TextService2")
            : data.type || "N/A",
        value: data.type || "",
      });
      setCompany({ label: data.partner_name || "N/A", value: data.partner_id || "" });
      setDateService(data.scheduled_start?.date || "");
      setHourService(data.scheduled_start?.time || "");
      setAditionalNote(data.info?.notes?.[0]?.message || "");
      setIdTag(data.info?.cost_center?.name || "");
  
      const markers = [];
  
      const normalizeLocation = (latlng) => {
        return {
          lat: Number(latlng.latitude),
          lng: Number(latlng.longitude ?? latlng.lon ?? latlng.lng),
        };
      };
  
      const origin = data.info?.origin?.address;
      if (origin) {
        const originData = {
          id: TypeAddress.ORIGIN,
          description: origin.description,
          location: normalizeLocation(origin.latlng),
          typeAddress: TypeAddress.ORIGIN,
          dragg: !isTripInProgress(data),
        };
        setOriginAddressService(originData);
        setSelectedOrigin(originData.location);
        markers.push(originData);
      }
  
      const destination = data.info?.destination?.address;
      if (destination) {
        const destinationData = {
          id: TypeAddress.DESTINY,
          description: destination.description,
          location: normalizeLocation(destination.latlng),
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
        };
        setDestinyAddressService(destinationData);
        setSelectedDestiny(destinationData.location);
        markers.push(destinationData);
      }
  
      const scales = data.info?.scales || [];
      const formattedScales = scales.map((scale, index) => ({
        id: index + 1,
        description: scale.address.description,
        location: normalizeLocation(scale.address.latlng),
        typeAddress: TypeAddress.ARRAY_SCALES,
        dragg: true,
        order: scale.order || index + 1,
      }));
      setArrScales(formattedScales);
      markers.push(...formattedScales);
  
      const riders = data.info?.riders || [];
      const formattedEmployees = riders.map((rider) => {
        const employeeInfo = findEmployees.find((emp) => emp.id === rider.id) || {};
  
        return {
          idEmployee: rider.id,
          id: rider.id,
          name: rider.name,
          identifier: employeeInfo.identifier || "N/A",
          depot: employeeInfo.depot || "N/A",
          addresses: employeeInfo.addresses || [],
          available_trips: employeeInfo.available_trips || 0,
          cost_center: employeeInfo.cost_center || { name: "N/A" },
          dropoff: rider.dropoff,
          address: employeeInfo.addresses?.[0] || {},
          is_individual_trip: false,
        };
      });
  
      setEmployeesSelectedFind(formattedEmployees);
      setEmployeesSelected(formattedEmployees);
      setAddressesMarkers(markers);
  
      if (riders.length > 0) {
        const employeeIds = riders.map((r) => r.id);
        getEmployeesAdmin(token, { ids: employeeIds.join(",") })
          .then((response) => {
            setFindEmployees(response.items);
          })
          .catch((error) => {
            console.error("Error fetching employees details:", error);
          });
      }
  
      riders.forEach((rider) => {
        if (!rider.dropoff.destination) {
          const scaleIndex = rider.dropoff.scale_order - 1;
          if (scaleIndex >= 0 && scaleIndex < formattedScales.length) {
            formattedScales[scaleIndex].employeeId = rider.id;
            formattedScales[scaleIndex].employeeName = rider.name;
          }
        }
      });
    } catch (error) {
      console.error("Error getting service request:", error);
      setErrorAlert(true);
      setErrorAlertMessage(error?.response?.data?.detail || error.message);
    }
  };

  const goToCreateEmployee = () => {
    navigate("/employees/create", {
      state: { from: "/request/create" },
    });
  };

  const onClickUpdateRequest = () => {
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    if (
      (!originAddressService?.location && typeService.value !== BookingType.ARRIVAL) ||
      (!destinyAddressService?.location && typeService.value === BookingType.CLOSED)
    ) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    const normalizeLatLng = (location) => {
      if (!location) return null;
      const lat = Number(location?.lat ?? location?.latitude);
      const lon = Number(location?.lon ?? location?.lng ?? location?.longitude);
      if (isNaN(lat) || isNaN(lon)) return null;
      return { latitude: lat, longitude: lon };
    };
  
    const sentScales = arrScales.filter(
      (scale) => scale.description && normalizeLatLng(scale.location),
    );

    const riderDropoff = (employeeId) => {
      const index = sentScales.findIndex(
        (scale) => employeeId === (scale.employeeId || scale.passenger_id),
      );
      return index < 0
        ? { destination: true, scale_order: 0 }
        : { destination: false, scale_order: index + 1 };
    };

    const patchPayload = {
      code: id.toString(),
      info: {
        origin: {
          address: {
            description: originAddressService.description,
            latlng: normalizeLatLng(originAddressService.location),
          },
        },
        ...(typeService.value === BookingType.CLOSED && {
          destination: {
            address: {
              description: destinyAddressService.description,
              latlng: normalizeLatLng(destinyAddressService.location),
            },
          },
          scales: sentScales.map((scale, index) => ({
            order: index + 1,
            address: {
              description: scale.description,
              latlng: normalizeLatLng(scale.location),
            },
          })),
        }),
        riders: employeesSelected.map((employee) => {
          const baseRider = {
            id: employee.idEmployee,
            name: employee.name,
            cost_center_id: employee.cost_center?.id || "",
            cost_center_name: employee.cost_center_name || "",
            dropoff: riderDropoff(employee.idEmployee),
          };
  
          if (
            typeService.value !== BookingType.CLOSED &&
            typeService.value !== BookingType.OPEN
          ) {
            return {
              ...baseRider,
              is_individual_trip: employee.is_individual_trip,
              address: {
                description:
                  employee.address?.address?.description ??
                  employee.address?.description ??
                  "",
                latlng: normalizeLatLng(
                  employee.address?.address?.location ??
                    employee.address?.location ??
                    null
                ),
              },
            };
          }
  
          return baseRider;
        }),
        ...(aditionalNote && {
          notes: [{ message: aditionalNote }],
        }),
        ...(idTag.trim() !== "" && {
          cost_center: {
            id: "",
            name: idTag.trim(),
          },
        }),
      },
    };
  
    if (patchPayload.info.riders.length === 0) {
      setErrorAlertMessage(i18n.t("AtLeastOneEmployeeRequired"));
      setErrorAlert(true);
      return;
    }
  
    if (typeService.value === BookingType.CLOSED && patchPayload.info.scales) {
      const invalidScales = patchPayload.info.scales.filter(
        (scale) =>
          !scale.address?.description ||
          !scale.address?.latlng ||
          isNaN(scale.address.latlng.latitude) ||
          isNaN(scale.address.latlng.longitude)
      );
  
      if (invalidScales.length > 0) {
        console.error("Invalid scales detected:", invalidScales);
        setErrorAlertMessage(i18n.t("InvalidScaleAddresses"));
        setErrorAlert(true);
        return;
      }
    }
  
    serviceEdit(patchPayload);
  };  

  const onClickCreateRequest = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }

    setIsSubmitting(true);
  
    if ((!originAddressService?.location && typeService.value !== BookingType.ARRIVAL) || 
        (!destinyAddressService?.location && typeService.value === BookingType.CLOSED)) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    try {
      for (let unitIndex = 0; unitIndex < units; unitIndex++) {
        const unitEmployees = groupedEmployees[unitIndex] || [];
  
        const arr = [];
        let scaleCounter = 1;
  
        unitEmployees.forEach((item) => {
          let body = {
            id: item.idEmployee,
            name: item.name,
            cost_center_id: item.cost_center_id ?? "N/A",
            cost_center_name: item.cost_center_name ?? "N/A",
            dropoff: {
              destination: true,
              scale_order: 0,
            },
          };
  
          arrScales.forEach((scale) => {
            if (scale.location && item.idEmployee === (scale.employeeId || scale.passenger_id)) {
              body.dropoff.destination = false;
              body.dropoff.scale_order = scaleCounter;
              scaleCounter++;
            }
          });
  
          if (typeService.value !== BookingType.CLOSED && typeService.value !== BookingType.OPEN) {
            body.is_individual_trip = item.is_individual_trip;
            body.address = {
              description: item.address.address.description,
              latlng: {
                latitude: item.address.address.location.lat,
                longitude: item.address.address.location.lon,
              },
            };
          }
          arr.push(body);
        });
  
        let formData = bodyGral();
        formData.info.riders = arr;
        formData.type = typeService.value;
        formData.info.unit_number = unitIndex + 1;
  
        switch (typeService.value) {
          case BookingType.OPEN:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;
  
          case BookingType.CLOSED:
            const onArrScales = arrScales
              .filter(scale =>
                scale.location &&
                (unitEmployees.some(e => e.idEmployee === (scale.employeeId || scale.passenger_id)) || !scale.employeeId)
              )
              .map((scale, index) => ({
                order: index + 1,
                address: {
                  description: scale.description,
                  latlng: {
                    latitude: scale.location.lat,
                    longitude: scale.location.lon || scale.location.lng,
                  },
                },
              }));
            formData.info.scales = onArrScales;
            formData.info.origin = {
              address: {
                description: originAddressService.description,
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            formData.info.destination = {
              address: {
                description: destinyAddressService.description,
                latlng: {
                  latitude: destinyAddressService.location.lat,
                  longitude: destinyAddressService.location.lon || destinyAddressService.location.lng,
                },
              },
            };
            break;
  
          case BookingType.ARRIVAL:
            formData.info.destination = {
              address: {
                description: destinyAddressService.description.toString(),
                latlng: {
                  latitude: destinyAddressService.location.lat,
                  longitude: destinyAddressService.location.lon,
                },
              },
            };
            break;
  
          case BookingType.LEAVING:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;
        }

        await serviceCreate(formData);
      }
      
    } catch (error) {
      console.error("Error creating requests:", error);
      setErrorAlertMessage(i18n.t("InvalidServiceType"));
      setErrorAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleScaleAddressChange = (newAddress, index) => {
    const updatedScales = [...arrScales];
    updatedScales[index] = {
        ...updatedScales[index],
        address: {
            description: newAddress.description,
            latlng: {
                latitude: newAddress.location.lat,
                longitude: newAddress.location.lon,
            },
        },
    };
    setArrScales(updatedScales);
  };

  const bodyGral = () => {
    const body = {
      company_id: company.value.toString(),
      scheduled_start: {
        timezone: "America/Mexico_City",
        date: dateService,
        time: hourService,
      },
      info: {},
    };
    if (aditionalNote) {
      body.info.notes = [{ message: aditionalNote }];
    }
  
    if (!disableTextarea && idTag.trim() !== "") {
      body.info.cost_center = {
        id: "",
        name: idTag.trim(),
      };
    }
  
    if (filteredEmployees.length > 0) {
      const requester = filteredEmployees[0];
      body.info.requested_by = {
        id: requester.id,
        name: requester.name,
      };
    }
  
    if (userProfile.username && userProfile.sub) {
      body.info.action_by = {
        id: userProfile.sub,
        name: userProfile.username,
      };
    }
  
    return body;
  };

  const bodyEditGral = () => {
    const normalizeLatLng = (location = {}) => {
      return {
        latitude: Number(location.lat),
        longitude: Number(location.lon ?? location.lng ?? location.longitude),
      };
    };
  
    const body = {
      requests: [
        {
          code: id.toString(),
          status: "UNASSIGNED",
          info: {
            type: typeService.value,
            scheduled_start: {
              timezone: "America/Mexico_City",
              date: dateService,
              time: hourService,
            },
            company_id: company.value.toString(),
            partner_name: company.label,
            origin: {
              address: {
                description: originAddressService.description,
                latlng: normalizeLatLng(originAddressService.location),
              },
            },
            ...(typeService.value === BookingType.CLOSED && {
              destination: {
                address: {
                  description: destinyAddressService.description,
                  latlng: normalizeLatLng(destinyAddressService.location),
                },
              },
            }),
            scales: arrScales.map((item, index) => ({
              order: item.order || index + 1,
              address: {
                description: item.description,
                latlng: normalizeLatLng(item.location),
              },
            })),
            riders: employeesSelected.map((item) => {
              const loc = item.address?.address?.location || item.address?.location || {};
              const desc = item.address?.address?.description || item.address?.description || "";
  
              return {
                id: item.idEmployee,
                name: item.name,
                dropoff: {
                  destination: item.dropoff?.destination ?? true,
                  scale_order: item.dropoff?.scale_order || 0,
                },
                ...(typeService.value !== BookingType.CLOSED &&
                  typeService.value !== BookingType.OPEN && {
                    is_individual_trip: item.is_individual_trip,
                    address: {
                      description: desc,
                      latlng: normalizeLatLng(loc),
                    },
                  }),
              };
            }),
            ...(aditionalNote && {
              notes: [{ message: aditionalNote }],
            }),
            ...(idTag.trim() !== "" && {
              cost_center: {
                id: "",
                name: idTag.trim(),
              },
            }),
            unit_number: currentService?.info?.unit_number || 1,
            metadata: currentService?.info?.metadata || {},
            proofs_of_service: currentService?.info?.proofs_of_service || [],
          },
        },
      ],
    };
  
    console.log("Payload to be sent for update:", body);
  
    return body;
  };

  const onGetEmployeesAdmin = (newOpts = { page: 1, service: true, size: 5, partner_id: company.value, status: EmployeeStatus.ACTIVE }) => {
    setLoading(true);
    getEmployeesAdmin(token, newOpts)
      .then((response) => {
        setOpts(newOpts);
        setEmployees(response);
        
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        const filteredItems = response.items.filter(emp => !selectedIds.includes(emp.id));
        
        setFindEmployees(filteredItems);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getEmployeesAdmin - ", error);
        setLoading(false);
      });
  };

  const getCompanies = () => {
    let arr = []
    onGetOrgsAdmin()
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const toggleTableVisibility = (index) => {
    setVisibleTables((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const groupedEmployees = chunk(employeesSelectedFind, 4);

  const onClickRemoveEmployee = (val) => {
    if (val.idEmployee === autoAddedEmployeeId) {
      setAutoAddedEmployeeId(null);
    }
    
    let updatedEmployeesSelected = [...employeesSelected];
    let updatedValidationsAddresses = [...validationsAddresses];
    let updatedFindEmployees = [...findEmployees];
    let updatedArrScales = [...arrScales];
    let updatedAddressesMarkers = [...addressesMarkers];

    const findEmployee = updatedEmployeesSelected.find((opt) => opt.id === val.id);
  
    if (findEmployee) {
      const findAddressVal = updatedValidationsAddresses.find(
        (opt) => opt.employee_id === val.address?.employee_id
      );
      if (findAddressVal) {
        updatedValidationsAddresses.splice(
          updatedValidationsAddresses.indexOf(findAddressVal),
          1
        );
      }

      updatedEmployeesSelected = updatedEmployeesSelected.filter(
        (opt) => opt.id !== val.id
      );

      updatedArrScales = updatedArrScales.filter(
        scale => !scale.employeeId || scale.employeeId !== findEmployee.idEmployee
      );

      updatedAddressesMarkers = updatedAddressesMarkers.filter(
        marker => !(marker.typeAddress === TypeAddress.ARRAY_SCALES && marker.employeeId === findEmployee.idEmployee)
      );

      updatedFindEmployees.push({
        id: findEmployee.idEmployee,
        identifier: findEmployee.identifier,
        name: findEmployee.name,
        depot: findEmployee.depot,
        phone: findEmployee.phone,
        cost_center: findEmployee.cost_center,
        addresses: findEmployee.addresses,
        available_trips: findEmployee.available_trips,
      });

      updatedEmployeesSelected.sort((a, b) => (a.id > b.id ? 1 : -1));
      updatedFindEmployees.sort((a, b) => (a.id > b.id ? 1 : -1));
      updatedArrScales.sort((a, b) => a.id - b.id);
  
      setValidationsAddresses([...updatedValidationsAddresses]);
      setEmployeesSelected([...updatedEmployeesSelected]);
      setEmployeesSelectedFind([...updatedEmployeesSelected]);
      setFindEmployees([...updatedFindEmployees]);
      setArrScales([...updatedArrScales]);
      setAddressesMarkers([...updatedAddressesMarkers]);
      setHasEmployeeScale(false);
    }
  };

  const onClickAddEmployees = (employee, isAutomaticSelection = false, isSingleUnitForMe = false) => {
    if (isAutomaticSelection || isSingleUnitForMe) {
      addEmployeeDirectly(employee, isAutomaticSelection, isSingleUnitForMe);
      return;
    }
  
    const existingEmployee = employeesSelected.find(
      (opt) => opt.idEmployee === employee.id
    );
  
    if (existingEmployee) {
      let updatedEmployeesSelected = employeesSelected.filter(
        (opt) => opt.idEmployee !== employee.id
      );
      let updatedFindEmployees = [...findEmployees];
      
      updatedFindEmployees.push({
        id: existingEmployee.idEmployee,
        identifier: existingEmployee.identifier,
        name: existingEmployee.name,
        depot: existingEmployee.depot,
        phone: existingEmployee.phone,
        cost_center: existingEmployee.cost_center,
        addresses: existingEmployee.addresses,
        available_trips: existingEmployee.available_trips,
      });
  
      let updatedArrScales = arrScales.filter(
        scale => !scale.employeeId || scale.employeeId !== employee.id
      );
      let updatedAddressesMarkers = addressesMarkers.filter(marker => 
        !(marker.typeAddress === TypeAddress.ARRAY_SCALES && marker.employeeId === employee.id)
      );
  
      setArrScales(updatedArrScales);
      setAddressesMarkers(updatedAddressesMarkers);
      setEmployeesSelected(updatedEmployeesSelected);
      setEmployeesSelectedFind(updatedEmployeesSelected);
      setFindEmployees(updatedFindEmployees);
      
      if (selectedOrigin && selectedDestiny) {
        setTimeout(() => {
          calculateRoute(selectedOrigin, selectedDestiny, updatedArrScales);
        }, 100);
      }
    } else {
      setPendingEmployee(employee);
      setPendingIsAutomaticSelection(isAutomaticSelection);
      setPendingIsSingleUnitForMe(isSingleUnitForMe);
      setShowScaleModal(true);
    }
  };
  
  const addEmployeeWithScaleDecision = (employee, useAsScale, isAutomaticSelection = false, isSingleUnitForMe = false) => {
    let updatedEmployeesSelected = [...employeesSelected];
    let updatedValidationsAddresses = [...validationsAddresses];
    let updatedFindEmployees = [...findEmployees];
    let updatedArrScales = [...arrScales];
    let updatedAddressesMarkers = [...addressesMarkers];
  
    const id = updatedEmployeesSelected.length !== 0
      ? updatedEmployeesSelected[updatedEmployeesSelected.length - 1].id + 1
      : 0;
  
    const newEmployee = {
      id: id,
      idEmployee: employee.id,
      addresses: employee.addresses,
      available_trips: employee.available_trips,
      is_individual_trip: isSingleUnitForMe,
      identifier: employee.identifier,
      name: employee.name,
      depot: employee.depot,
      phone: employee.phone,
      cost_center: employee.cost_center,
      cost_center_id: employee.cost_center?.id || "",
      cost_center_name: employee.cost_center?.name || "",
      address: employee.addresses.length === 1 ? employee.addresses[0] : {},
      dropoff: { destination: true },
      isAutoAdded: isAutomaticSelection
    };
    
    if (isAutomaticSelection) {
      setAutoAddedEmployeeId(employee.id);
    }
    
    updatedEmployeesSelected.push(newEmployee);
  
    const shouldAddAsScale = useAsScale && 
                           employee.addresses.length > 0 && 
                           !isSingleUnitForMe && 
                           typeService.value === BookingType.CLOSED;
  
    if (shouldAddAsScale) {
      const address = employee.addresses[0].address;
      const scaleId = updatedArrScales.length > 0 
        ? Math.max(...updatedArrScales.map(s => s.id)) + 1 
        : 3;
  
      const newScale = {
        id: scaleId,
        description: address.description,
        location: {
          lat: address.location.lat,
          lng: address.location.lon || address.location.lng,
        },
        dragg: true,
        typeAddress: TypeAddress.ARRAY_SCALES,
        employeeId: employee.id,
        employeeName: employee.name,
        stopover: true,
      };
      
      updatedArrScales.push(newScale);
      updatedAddressesMarkers.push({
        ...newScale,
        id: `scale-${scaleId}`,
        typeAddress: TypeAddress.ARRAY_SCALES,
        location: newScale.location,
      });
  
      if (employee.addresses.length === 1 && typeService.value === BookingType.ARRIVAL) {
        updatedValidationsAddresses.push(employee.addresses[0]);
      }
    }
  
    updatedFindEmployees = updatedFindEmployees.filter(
      (emp) => emp.id !== employee.id
    );
  
    setArrScales(updatedArrScales);
    setAddressesMarkers(updatedAddressesMarkers);
    setValidationsAddresses(updatedValidationsAddresses);
    setEmployeesSelected(updatedEmployeesSelected);
    setEmployeesSelectedFind(updatedEmployeesSelected);
    setFindEmployees(updatedFindEmployees);
    setHasEmployeeScale(true);
  
    if (selectedOrigin && selectedDestiny) {
      setTimeout(() => {
        calculateRoute(selectedOrigin, selectedDestiny, updatedArrScales);
      }, 100);
    }
  };
  
  const addEmployeeDirectly = (employee, isAutomaticSelection = false, isSingleUnitForMe = false) => {
    addEmployeeWithScaleDecision(employee, true, isAutomaticSelection, isSingleUnitForMe);
  };
  
  const handleScaleModalResponse = (useAsScale) => {
    if (pendingEmployee) {
      addEmployeeWithScaleDecision(pendingEmployee, useAsScale, pendingIsAutomaticSelection, pendingIsSingleUnitForMe);
    }
    setShowScaleModal(false);
    setPendingEmployee(null);
    setPendingIsAutomaticSelection(false);
    setPendingIsSingleUnitForMe(false);
  };
  
  const handleScaleModalCancel = () => {
    setShowScaleModal(false);
    setPendingEmployee(null);
    setPendingIsAutomaticSelection(false);
    setPendingIsSingleUnitForMe(false);
  };

  const onClickShowEmployees = () => {
    dropDownHidde(!showEmployees, VisibilityTypes.EMPLOYEES);
    setShowAddEmployeeLink(false);
    
    if (isEditMode && company.value) {
      const initialOpts = { 
        partner_id: company.value, 
        size: 5, 
        status: EmployeeStatus.ACTIVE,
        page: 1
      };
      onGetEmployeesAdmin(initialOpts);
    }
  };

  const getLastVisibleTableIndex = () => {
    const visibleIndices = Object.keys(visibleTables)
      .filter(key => visibleTables[key])
      .map(key => parseInt(key))
      .sort((a, b) => a - b);
    
    return visibleIndices.length > 0 ? visibleIndices[visibleIndices.length - 1] : -1;
  };

  const enterEditMode = () => {
    setEditingEmployees(groupedEmployees.flat().map(emp => ({
      ...emp,
      selectedAddress: emp.selectedAddress || emp.addresses[0]?.address || null
    })));
    setIsEditing(true);
    setShowEmployeesAvailable(false);
    setVisibleTables({});
  };
  
  const handleEmployeeEdit = (index, field, value) => {
    const updatedEmployees = [...editingEmployees];
    updatedEmployees[index] = {
      ...updatedEmployees[index],
      [field]: value
    };
    setEditingEmployees(updatedEmployees);
  };

  const handleSave = async () => {
    if (newAddress && selectedEmployeeId) {
      await onClickSaveAddress();
    }
    
    const updatedSelectedEmployees = groupedEmployees.flat().map(employee => {
      const editedEmployee = editingEmployees.find(e => e.id === employee.id);
      return editedEmployee ? editedEmployee : employee;
    });
    
    setEmployeesSelectedFind(updatedSelectedEmployees);

    setIsEditing(false);
  };

  const handleAddUnregisteredEmployee = () => {
    const id = employeesSelected.length !== 0
      ? employeesSelected[employeesSelected.length - 1].id + 1
      : 0;

    const newEmployee = {
      id: id,
      idEmployee: "N/A",
      name: unregisteredEmployee.name,
      depot: unregisteredEmployee.depot,
      addresses: [],
      available_trips: null,
      cost_center: null,
      is_individual_trip: false,
      dropoff: { destination: true },
    };

    setEmployeesSelected([...employeesSelected, newEmployee]);
    setEmployeesSelectedFind([...employeesSelected, newEmployee]);

    setUnregisteredEmployee({ name: "", phone: "" });
    setShowAddEmployeeForm(false);
  };  

  const handleCancelAddEmployee = () => {
    setShowAddEmployeeForm(false);
    setUnregisteredEmployee({ name: "", phone: "" });
  };

  const onChangeCompany = (e) => {
    setEmployeesSelectedFind([]);
    setEmployeesSelected([]);
    setSearchResults([]);
    setShowDropdown(false);
    setSearchQuery("");
    setFilteredEmployees([]);
    setSelectedOption(null);
    setEmployeeNumber("");
    
    setShowNextBlock(false);
    setShowSelect(false);
    setSelectedServiceOption(null);
    setSelectedUnitOption(null);
    
    setShowCompany(false);
    setShowDateHour(true);
    setErrors((prevErrors) => ({ ...prevErrors, company: false }));
    
    if (!isFirstCompanySelection) {
        setOriginAddressService({});
        setDestinyAddressService({});
        setAddressesMarkers([]);
        setSelectedOrigin(null);
        setSelectedDestiny(null);
        setKey(prev => prev + 1);
    }
    
    setCompany(e);
    
    setShowGeneral(true);
    setShowTypeService(false);
    setShowAddresses(false);
    setShowUnits(false);
    setShowIdTag(false);
    setShowEmployees(false);
    setShowScales(false);
    
    setIsFirstCompanySelection(false);
  };
  
  const onChangeTypeService = (e) => {
    setShowTypeService(false);
    setShowAddresses(true);
    setTypeService(e);
    setOriginAddressService({});
    setDestinyAddressService({});
    setUnits(1);
    setAddressesMarkers([]);
    setError('typeService', false);
  };

  const handleValidateTypeService = () => {
    if (!typeService.value) {
      setError('typeService', true);
    }
  };
  
  const onBlurUnits = (val) => {
    setUnits(val)
  };

  const fillCompany = () => {
    setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
  };
  
  const fillTypeService = () => {
    const defaultService = {
      label: i18n.t("TextService2"),
      value: BookingType.CLOSED
    };
    
    let arr = [
      { label: i18n.t("TextService1"), value: BookingType.OPEN },
      defaultService,
      // { label: i18n.t("TextService3"), value: BookingType.ARRIVAL },
      // { label: i18n.t("TextService4"), value: BookingType.LEAVING },
    ];
    
    setListTypeService([...arr]);
    
    if (!typeService.value) {
      setTypeService(defaultService);
    }
  };

  const onChangeDate = (e) => {
    const selectedDate = e[0];
    if (selectedDate) {
      setDateService(`${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`);
      setError('date', false);
    } else {
      setError('date', true);
    }
  };
  
  const onChangeHour = (e) => {
    const selectedHour = e[0];
    if (selectedHour) {
      setHourService(`${selectedHour.getHours().toString().padStart(2, '0')}:${selectedHour.getMinutes().toString().padStart(2, '0')}`);
      setError('hour', false);
    } else {
      setError('hour', true);
    }
  };

  const onBlurAditionalNote = (val) => {
    setShowDateHour(false)
    setShowTypeService(true)
    setAditionalNote(val)
  };

  const dropDownHidde = (val, type) => {
    setShowCompany(type === VisibilityTypes.COMPANY ? true : false)
    setShowGeneral(type === VisibilityTypes.GENERAL ? true : false)
    setShowDateHour(type === VisibilityTypes.DATE_HOUR ? true : false)
    setShowAdditionalNote(type === VisibilityTypes.ADDITIONAL_NOTE ? true : false)
    setShowTypeService(type === VisibilityTypes.TYPE_SERVICE ? true : false)
    setShowAddresses(type === VisibilityTypes.ADDRESSES ? true : false)
    setShowUnits(type === VisibilityTypes.UNITS ? true : false)
    setShowIdTag(type === VisibilityTypes.IDTAG ? true: false)
    setShowEmployees(type === VisibilityTypes.EMPLOYEES ? true : false)
    setShowScales(type === VisibilityTypes.SCALES ? true : false)
  };
  
  const onClickAccept = () => {
    setShowEmployees(false);
  };
  
  const onClickCancel = () => {
    setShowEmployees(false);
    setShowAddEmployeeLink(true); 
  };
  
  const validateAddresses = useCallback(() => {
    setErrors(prev => ({
      ...prev,
      origin: typeService.value !== BookingType.ARRIVAL && !originAddressService.description,
      destiny: typeService.value === BookingType.CLOSED && !destinyAddressService.description
    }));
  }, [typeService.value, originAddressService.description, destinyAddressService.description]);

  const handleSearch = (value) => {
    setSearchQuery(value);
    
    if (value.trim() === "") {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
  
    if (value.trim().length < 3) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
  
    setLoading(true);
    setShowDropdown(true);
  
    // SPECIFIC CLIENT CASE: RONAL (partner_id: 12490)
    const searchValue = company.value === 12490 ? "ronalgroup.com" : value;
  
    const params = {
      status: "ACTIVE",
      partner_id: company.value,
      search: searchValue
    };
  
    getEmployeesAdmin(token, params)
      .then((response) => {
        setSearchResults(response.items.slice(0, 5));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error searching employees:", error);
        setSearchResults([]);
        setLoading(false);
      });
  };
  
  const handleEmployeeSelect = (employee) => {
    const displayValue = [
      employee.name, 
      employee.email, 
      employee.identifier, 
      employee.phone
    ].find(value => value && value.trim() !== "");
    
    setSearchQuery(displayValue || "");
    
    if (!employee.name && !employee.email && !employee.identifier && !employee.phone) {
      console.error("The employee does not have sufficient data");
      setErrorAlertMessage(i18n.t("IncompleteEmployeeData"));
      setErrorAlert(true);
      return;
    }
  
    const completeEmployee = {
      ...employee,
      identifier: employee.identifier || "N/A",
      email: employee.email,
      phone: employee.phone,
      cost_center: employee.cost_center || { name: "N/A" }
    };
  
    setFilteredEmployees([completeEmployee]);
    setShowDropdown(false);
    
    setEmployeeNumber(completeEmployee.identifier);
    setSelectedOption({ value: "Employee", label: "Employee" });
  };

  const onClickFilterList = (type = null) => {
    let arr = [];
    buttonSearch1 ? setFilterName("") : null;
    buttonSearch2 ? setFilterName2("") : null;
    buttonSearch1
      ? (document.getElementById(
          `${type == "init" ? "filter1Name" : "filter2Name"}`
        ).value = null)
      : null;
    buttonSearch2
      ? (document.getElementById(
          `${type == "init" ? "filter2Name" : "filter1Name"}`
        ).value = null)
      : null;
    type == "init"
      ? onGetEmployeesAdmin({ page: 1, size: 10, name: filterName })
      : findSetEmployeesSelecteed();
    type == "init" ? setButtonSearch1(!buttonSearch1) : setButtonSearch2(!buttonSearch2);
  };
  
  const handleAddRowScale = () => {
    const maxId = arrScales.length > 0 
      ? Math.max(...arrScales.map(scale => scale.id ?? 0)) 
      : 0;
  
    const newRowScale = {
      id: maxId + 1,
      editRow: true,
      typeAddress: TypeAddress.ARRAY_SCALES,
      address: {
        description: null,
        location: { lat: 0, lon: 0 }
      },
      name: "",
    };
  
    setArrScales(prev => [...prev, newRowScale]);
  };
  
  const handleRemoveRowScale = (id) => {
    if (arrScales.length === 1) {
      setArrScales([
        {
          id: 0,
          latLon: false,
          passenger_id: null,
          name: null,
          typeAddress: TypeAddress.ARRAY_SCALES,
          address: {
            location: { lon: -99.1446503251791, lat: 19.46416132507601 },
          },
        },
      ]);
    } else {
      const updatedRows = arrScales.filter((row) => row.id !== id);
      const updatedAddressesMarkers = addressesMarkers.filter(
        (marker) => marker.id !== id
      );
  
      setAddressesMarkers(updatedAddressesMarkers);
      setArrScales(updatedRows);
    }
  };

  const findSetEmployeesSelecteed = () => {
    let arr = [];
    employeesSelected.map((emps) => {
      emps.name.includes(filterName2) ? arr.push(emps) : null;
    });
    setEmployeesSelectedFind([...arr]);
  };
  
  const onChangeAddress = (e, employee) => {
    var set_employees = employeesSelected;
    var onValidationsAddresses = validationsAddresses;
    var findEmployee = set_employees
      .filter(function (opt) {
        return opt.idEmployee == employee.idEmployee;
      })
      .shift();
    if (findEmployee) {
      var findAddress = findEmployee.addresses
        .filter(function (opt) {
          return opt.employee_id == e.employee_id;
        })
        .shift();
      var findAddressVal = validationsAddresses
        .filter(function (opt) {
          return opt.employee_id == e.employee_id;
        })
        .shift();
      findEmployee.address = e;
      if (findAddressVal)
        onValidationsAddresses.splice(
          onValidationsAddresses.indexOf(findAddressVal),
          1
        );
      onValidationsAddresses.push(e);
      onValidationsAddresses.sort((a, b) => (a.id > b.id ? 1 : -1));
      setValidationsAddresses([...onValidationsAddresses]);
      set_employees.splice(set_employees.indexOf(findEmployee), 1);
      set_employees.push(findEmployee);
      set_employees.sort((a, b) => (a.id > b.id ? 1 : -1));
      setEmployeesSelected(set_employees);
      setEmployeesSelectedFind(set_employees);
    }
  };
  
  const onChangeAddScalesRow = (formRow, val, nameInput, type) => {
    let rowScale = null;
    let address = type == "address" ? val : "";
    let [lat, lon] = "";
    let passenger = type == "passenger" ? val : {};
    if (arrScales.length == 0) {
      rowScale = {
        id: formRow.id,
        addresssMap: true,
        editRow: true,
        address: { description: null, location: { lat, lon } },
        name: passenger.label,
      };
      arrScales.push(rowScale);
    } else {
      rowScale = arrScales
        .filter(function (opt) {
          return opt.id === formRow.id;
        })
        .shift();
      if (rowScale) {
        rowScale.name = type == "passenger" ? passenger.label : rowScale.name;
        rowScale.address = type == "address" ? val : rowScale.address;
        arrScales.splice(arrScales.indexOf(rowScale), 1);
        arrScales.push(rowScale);
      } else {
        rowScale = {
          id: formRow.id,
          editRow: true,
          addresssMap: true,
          address: { description: null, location: { lat, lon } },
          name: passenger.label,
        };
        arrScales.push(rowScale);
      }
    }
    if (passenger.value) {
      let employee = employeesSelected
        .filter(function (opt) {
          return opt.idEmployee === passenger.value;
        })
        .shift();
      employeesSelected.splice(employeesSelected.indexOf(employee), 1);
      employee.dropoff.destination = false;
      employee.dropoff.scale_number = rowScale.id + 1;
      employeesSelected.push(employee);
      setEmployeesSelected([...employeesSelected]);
    }
    document.getElementById(nameInput).value = val.formattedAddress;
  };  

  const serviceCreate = (formData) => {
    postServicesAdmin(token, formData)
      .then((response) => {
        if (response.code) {
          setServiceCode(response.code);
          setErrorAlert(false);
          localStorage.setItem("notify", "true");
          localStorage.setItem("headerText", i18n.t("SolicitedService"));
          localStorage.setItem(
            "bodyText",
            i18n.t("SuccessRequestServiceWithCode", {
              code: `<a href="/services/request/${response.code}">${response.code}</a>`,
            })
          );
  
          const redirectPath = infoUser?.is_staff
            ? "/services/general"
            : "/services/request";
  
          window.dispatchEvent(new Event("storage"));
          history(redirectPath);
        }
      })
      .catch((error) => {
        console.error("Error - postServicesAdmin ", error);
        setErrorAlert(true);
        
        if (error?.response?.data?.error?.message?.message === "Rider(s) overlap") {
          const overlapData = error.response.data.error.message.riders_overlap;
          
          if (overlapData && overlapData.length > 0) {
            const rider = overlapData[0];
            const formattedDate = rider.service_scheduled_start.date;
            const formattedTime = rider.service_scheduled_start.time.substring(0, 5);
            const timezone = rider.service_scheduled_start.timezone;
  
            const errorMessage = i18n.t("RiderOverlapError", {
              riderName: rider.rider_name,
              serviceCode: rider.service_code,
              date: formattedDate,
              time: formattedTime
            });
            
            setErrorAlertMessage(errorMessage);
          } else {
            setErrorAlertMessage(i18n.t("RiderOverlapGenericError"));
          }
        } else if (error.code == 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        } else {
          setErrorAlertMessage(
            JSON.stringify(error?.response?.data?.detail || error.message)
          );
        }
      });
  };

  const serviceEdit = async (patchPayload) => {
    try {
      const response = await patchUpdateRequest(token, id, patchPayload);
  
      if (response.code) {
        setErrorAlert(false);
        localStorage.setItem("notify", "true");
        localStorage.setItem("headerText", i18n.t("UpdatedService"));
        localStorage.setItem("bodyText", i18n.t("SuccessUpdatedService"));
  
        const redirectPath = infoUser?.is_staff
          ? "/services/general"
          : "/services/request";
  
        history(redirectPath);
      }
    } catch (error) {
      console.error("Error - patchUpdateRequest:", error);
      setErrorAlert(true);
      setErrorAlertMessage(
        routeEditErrorMessage(error) ||
          JSON.stringify(error?.response?.data?.detail || error.message)
      );
  
      if (error.code === 500) {
        setErrorAlertMessage(i18n.t("ServerError"));
      }
    }
  };

  const isDisabled = useMemo(() => {
    const hasNoEmployeesOrUnits = employeesSelectedFind.length === 0 && (!units || units < 2);
    const hasNoOrigin = !originAddressService?.location;
    const hasNoDestiny = !destinyAddressService?.location;
    const shouldValidateIdTag = isPartnerAllowed(company.value || infoUser?.partner_id);
    const hasNoIdTag = shouldValidateIdTag && (!idTag || idTag.trim() === '');
  
    if (typeService.value === BookingType.OPEN) {
      return hasNoOrigin || hasNoEmployeesOrUnits || hasNoIdTag;
    }
  
    return hasNoOrigin || hasNoDestiny || hasNoEmployeesOrUnits || hasNoIdTag;
  }, [typeService.value, originAddressService?.location, destinyAddressService?.location, employeesSelectedFind, units, company.value, infoUser?.partner_id, idTag]);

  const onChangeUseFileEmployees = (e) => {
    setShowEmployeesAvailable(e.target.checked);
    onGetEmployeesAdmin();
    setCheckFileEmployee(e.target.checked);
  };

  const onChangeFile = async (e) => {
    const arr = [];
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "",
    });    
    setSelectFile(file);    
    jsonData.map((item, index) => {
      if (index > 0) {
        getEmployeesAdmin(token, { size: 10, page: 1, email: item[0] })
          .then((response) => {
            const employee = response.items[0];            
            if (employee.addresses.length === 0) {
              setErrorAlert(true);
              setErrorAlertMessage("Sin dirección");
            }            
            const currentArr = [...employeesSelected];
            const id = currentArr.length === 0 ? 1 : currentArr[currentArr.length - 1].id + 1;            
            const dataResp = {
              id: id,
              idEmployee: employee.id,
              addresses: employee.addresses,
              is_individual_trip: false,
              name: employee.name,
              address: employee.addresses.length === 1 ? employee.addresses[0] : {},
              dropoff: { destination: true },
            };            
            currentArr.push(dataResp);
            setEmployeesSelected(currentArr);
            setEmployeesSelectedFind(currentArr);
          })
          .catch((error) => {
            console.error("Error - getEmployeesAdmin(onChangeFile) - ", error);
          });
      }
    });
  };

  const updateEmployeeScale = (employeeId, newAddress) => {
    const updatedScales = arrScales.map(scale => 
      scale.employeeId === employeeId 
        ? {
            ...scale,
            description: newAddress.description,
            location: {
              lat: newAddress.location.lat,
              lng: newAddress.location.lon || newAddress.location.lng
            }
          }
        : scale
    );
    
    setArrScales(updatedScales);
  
    const updatedMarkers = addressesMarkers.map(marker => {
      if (marker.employeeId === employeeId && marker.typeAddress === TypeAddress.ARRAY_SCALES) {
        const updatedScale = updatedScales.find(s => s.employeeId === employeeId);
        return {
          ...marker,
          ...updatedScale
        };
      }
      return marker;
    });
  
    setAddressesMarkers(updatedMarkers);
  
    if (selectedOrigin && selectedDestiny) {
      calculateRoute(selectedOrigin, selectedDestiny, updatedScales);
    }
  };

  useEffect(() => {
    validateAddresses();
  }, [originAddressService, destinyAddressService, validateAddresses]);

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("Services")} link='/services/request' breadcrumbItem={i18n.t("ServiceRequest")} />
          <div className="container-fluid">
            {isInProgress && (
              <Alert color="warning" className="mb-3">
                <strong>{i18n.t("RouteEditInProgressTitle")}</strong>{" "}
                {i18n.t("RouteEditInProgressBody")}
              </Alert>
            )}
            <Card>
              <Row className="p-3">
                <Col xxl={showEmployees ? 12 : 6} md={showEmployees ? 12 : 6} xs={12} className="">
                  {(!showEmployees && infoUser.is_staff) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showCompany, VisibilityTypes.COMPANY)} 
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("Partner")} ${company.label ? `(${company.label})` : ""} ` }
                          <i className={ `${showCompany ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">{i18n.t("SelectCompanyService")}</p>
                      {showCompany && (
                        <Card className="custom-select-card">
                          <Select
                            name="company"
                            placeholder={i18n.t("SelectCompany")}
                            value={listCompanies.filter((c) => c.value == company.value)}
                            options={listCompanies}
                            className="select2-selection"
                            onChange={(e) => {
                              onChangeCompany(e);
                              dropDownHidde(true, VisibilityTypes.GENERAL);
                            }}
                            isDisabled={isEditMode}
                          />
                          {errors.company && (
                            <span className="error-message">
                              <i className="fa fa-exclamation-circle" />
                              {i18n.t("CompanyError")}
                            </span>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {(!isEditMode && !showEmployees && infoUser.is_staff) && <hr />}
                  {(!showEmployees && !isEditMode) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showGeneral, VisibilityTypes.GENERAL)} 
                      >
                        <h6 className="request-create-title">
                          {i18n.t("General")}
                          <i className={ `${showGeneral ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">{i18n.t("EnterTheEmployeeNumber")}</p>
                      {showGeneral && (
                        <Card className="custom-select-card">
                          <div className="search-container">
                            <Input
                              className="input-employee-data"
                              value={searchQuery}
                              placeholder={i18n.t("EnterTheEmployeeInfo")}
                              onChange={(e) => handleSearch(e.target.value)}
                              onFocus={() => searchQuery && setShowDropdown(true)}
                              onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                              disabled={!company.value}
                            />                         
                            {showDropdown && company.value && (
                              <div className="search-dropdown">
                                {searchResults.length > 0 ? (
                                  searchResults.map((employee, index) => (
                                    <div 
                                      key={index}
                                      className="dropdown-item"
                                      onClick={() => handleEmployeeSelect(employee)}
                                    >
                                      <div>
                                        <strong>{employee.name}</strong>
                                        <div className="text-muted small">
                                          {employee.identifier && `ID: ${employee.identifier}`}
                                          {employee.email && ` | Email: ${employee.email}`}
                                          {employee.phone && ` | Tel: ${employee.phone}`}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  infoUser.is_staff && (
                                    <Link 
                                      to="/employees/create" 
                                      className="dropdown-item add-employee-link"
                                      onClick={() => {
                                        sessionStorage.setItem('selectedCompany', JSON.stringify({
                                          value: company.value,
                                          label: company.label
                                        }));
                                        sessionStorage.setItem('employeeRedirectTo', '/services/request/create');
                                      }}
                                    >
                                      <i className="bx bx-plus add-employee-icon" />
                                      {i18n.t("AddNewEmployee")}
                                    </Link>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                          <p/>
                          {employeeNumber.trim() !== "" && selectedOption && (
                            <>
                              <p className="request-create-text" htmlFor="companyInput">
                                {i18n.t("ConfirmedEmployeeInformation")}
                              </p>
                              <div className="table-responsive pt-3">
                                <Table className="table table-responsive">
                                  <thead>
                                    <tr>
                                      <th className="bg-light">{i18n.t("NoEmployee")}</th>
                                      <th className="bg-light">{i18n.t("Name")}</th>
                                      <th className="bg-light">{i18n.t("Email")}</th>
                                      <th className="bg-light cost-center-header">{i18n.t("CostCenter")}</th>
                                      <th className="bg-light">{i18n.t("Services")}</th>
                                      <th className="bg-light">{i18n.t("Department")}</th>
                                    </tr>
                                  </thead>
                                  {isLoading ? null : (
                                    <tbody>
                                      {filteredEmployees.map((employee, key) => (
                                        <tr key={key}>
                                          <td>{employee.identifier}</td>
                                          <td>{employee.name}</td>
                                          <td>{employee.email}</td>
                                          <td>{employee.cost_center?.name || "N/A"}</td>
                                          <td>{!employee.cost_center_id || employee.available_trips === -1
                                            ? i18n.t("NotApplicable")
                                            : employee.available_trips}
                                          </td>
                                          <td>{employee.depot || "N/A"}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  )}
                                </Table>
                                {!showSelect && (
                                  <div>
                                    <button
                                      onClick={() => setShowSelect(true)}
                                      className="btn btn-request"
                                      disabled={
                                        filteredEmployees.length > 0 && 
                                        filteredEmployees[0].cost_center_id && 
                                        filteredEmployees[0].available_trips === 0
                                      }
                                    >
                                      {i18n.t("TheInfoIsCorrect")}
                                    </button>                                   
                                    {filteredEmployees.length > 0 && 
                                    filteredEmployees[0].cost_center_id && 
                                    filteredEmployees[0].available_trips === 0 && (
                                      <span className="text-danger small d-flex align-items-center gap-1">
                                        <i className="fa fa-exclamation-circle"/>
                                        {i18n.t("EmployeeHasNoAvailableServices")}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                              {showSelect && (
                                <>
                                  <p className="request-create-text" htmlFor="companyInput">
                                    {i18n.t("SelectServiceFor")}
                                  </p>
                                  <Select
                                    placeholder={i18n.t("IsTheServiceForYou")}
                                    options={[
                                      { value: "TheServiceIsForMe", label: i18n.t("TheServiceIsForMe") },
                                      { value: "TheServiceIsForSomeoneElse", label: i18n.t("TheServiceIsForSomeoneElse") },
                                    ]}
                                    value={selectedServiceOption}
                                    onChange={(selectedOption) => {
                                      setSelectedServiceOption(selectedOption);
                                      setShowUnitSelect(true);
                                      
                                      if (selectedOption.value === "TheServiceIsForMe" && filteredEmployees.length > 0) {
                                        const employee = filteredEmployees[0];
                                        onClickAddEmployees(employee, true, true);
                                        setAutoAddedEmployeeId(employee.id);

                                        if (employee.addresses?.length > 0) {
                                          setEmployeeAddress({
                                            description: employee.addresses[0].address.description,
                                            location: {
                                              lat: employee.addresses[0].address.location.lat,
                                              lng: employee.addresses[0].address.location.lon
                                            }
                                          });
                                        }
                                      } else {
                                        setEmployeeAddress(null);
                                        setAutoAddedEmployeeId(null);
                                      }
                                    }}
                                  />
                                </>
                              )}   
                              {showUnitSelect && (
                                <>
                                  <p className="request-create-text" htmlFor="companyInput">
                                    {i18n.t("SelectUnitOption")}
                                  </p>
                                  <Select
                                    placeholder={i18n.t("UnitOptions")}
                                    options={[
                                      { value: "SingleUnit", label: i18n.t("SingleUnit") },
                                      { value: "SharedUnit", label: i18n.t("SharedUnit") },
                                    ]}
                                    value={selectedUnitOption}
                                    onChange={(selectedOption) => {
                                      setSelectedUnitOption(selectedOption);
                                      setShowNextBlock(true);
                                      setShowDateHour(true);
                                      setShowGeneral(false);
                                      
                                      if (selectedOption.value === "SingleUnit" && employeeAddress) {
                                        const newDestiny = {
                                          description: employeeAddress.description,
                                          location: employeeAddress.location,
                                          dragg: true,
                                          typeAddress: TypeAddress.DESTINY
                                        };
                                        
                                        setDestinyAddressService(newDestiny);
                                        setSelectedDestiny(newDestiny);
                                        
                                        setAddressesMarkers(prev => [
                                          ...prev.filter(m => m.typeAddress !== TypeAddress.DESTINY),
                                          {
                                            ...newDestiny,
                                            id: `destiny-${filteredEmployees[0]?.id || 'employee'}`
                                          }
                                        ]);
                                        
                                        if (selectedServiceOption?.value === "TheServiceIsForMe") {
                                          setArrScales(prev => prev.filter(scale => scale.employeeId !== filteredEmployees[0]?.id));
                                        }
                                      }
                                    }}
                                  />
                                </>
                              )}
                            </>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {showNextBlock && (
                    <>
                      {!isEditMode && !showEmployees && <hr />}
                      {!isEditMode && !showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => company.value && dropDownHidde(!showDateHour, VisibilityTypes.DATE_HOUR)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("DateHourService")} ${(dateService && hourService) ? `(${dateService} - ${hourService})` : ''}`}
                              <i className={ `${showDateHour ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text">{i18n.t("SelectDateHourService")}</p>
                          {showDateHour && (
                            <Row>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Date")}</Label>
                                  <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectDate")}
                                      value={dateService}
                                      onChange={(e) => onChangeDate(e)}
                                      options={{
                                        minDate: "today",
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "Y-m-d",
                                        defaultDate: new Date()
                                      }}
                                    />
                                    <i className="mdi mdi-calendar-outline input-icon" />
                                  </div>
                                  {errors.date && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("DateError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Hour")}</Label>
                                <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectHour")}
                                      value={hourService}
                                      onChange={(e) => onChangeHour(e)}
                                      options={{
                                        minDate: "today",
                                        minTime: minTime,
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "H:i",
                                        time_24hr: true,
                                        defaultDate: (() => {
                                          const now = new Date();
                                          now.setMinutes(now.getMinutes() + 25);
                                          return now;
                                        })(),
                                      }}
                                    />
                                  <i className="mdi mdi-clock-outline input-icon" />
                                </div>
                                  {errors.hour && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("HourError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {!showEmployees && <hr />}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (dateService && hourService) && dropDownHidde(!showAdditionalNote, VisibilityTypes.ADDITIONAL_NOTE)}
                          >
                            <h6 className="request-create-title">
                              {i18n.t("AditionalNote")}
                              <i className={ `${showAdditionalNote ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("DescAditionalNote")}
                          </p>
                          {showAdditionalNote && (
                            <>
                              <Input
                                type="textarea"
                                value={aditionalNote}
                                placeholder={i18n.t("WriteYourNoteHere")}
                                onChange={(e) => setAditionalNote(e.target.value)}
                                onBlur={(e) => onBlurAditionalNote(e.target.value)}
                              />
                            </>
                          )}
                        </Col>
                      )}
                      {!showEmployees && !isEditMode && <hr />}
                      {!showEmployees && !isEditMode && ( 
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (dateService && hourService) && dropDownHidde(!showTypeService, VisibilityTypes.TYPE_SERVICE)}
                          >
                            <h6 className="request-create-title">
                              { `${i18n.t("TypeService")} ${typeService.label ? `(${typeService.label})` : ""} ` }
                              <i className={ `${showTypeService ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectTypeService")}
                          </p>
                          {showTypeService && (
                            <Card className="custom-select-card">
                              <Select
                                name="typeService"
                                placeholder={i18n.t("SelectTheTypeService")}
                                value={listTypeService.filter((c) => c.value == typeService.value)}
                                options={listTypeService}
                                className="select2-selection"
                                onChange={(e) => onChangeTypeService(e)}
                                onBlur={handleValidateTypeService}
                              />
                              {errors.typeService && (
                                <span className="error-message">
                                  <i className="fa fa-exclamation-circle"></i>
                                  {i18n.t("TypeServiceError")}
                                </span>
                              )}
                            </Card>
                          )}
                        </Col>
                      )}
                      {!showEmployees && <hr />}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => {
                              typeService.value && dropDownHidde(!showAddresses, VisibilityTypes.ADDRESSES);
                              validateAddresses();
                            }}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("Addresses")} ${(originAddressService.location || destinyAddressService.location) ? `(${i18n.t("ShowMore")})` : ""}`}
                              <i className={ `${showAddresses ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          {!showAddresses && (
                            <p className="request-create-text" htmlFor="companyInput">
                              {i18n.t("SelectAddresses")}
                            </p>
                          )}
                          {showAddresses && (
                            <Row>
                              {typeService.value === BookingType.ARRIVAL ? null : (
                                <Col xxl={6} xl={6} xs={12} className="address-input">  
                                  <p className="request-create-text" htmlFor="companyInput">
                                  {typeService.value === BookingType.OPEN
                                    ? i18n.t("TextOpenRequestAddress")
                                    : i18n.t("TextAddressRequest")}
                                  </p>
                                  <PlacesServices
                                    selectedOrigin={selectedOrigin}
                                    setAddressesMarkers={setAddressesMarkers}
                                    addressesMarkers={addressesMarkers}
                                    selectedAddress={originAddressService}
                                    setSelectedAddress={(address) => {
                                      setOriginAddressService(address);
                                      setErrors(prev => ({...prev, origin: false}));
                                    }}
                                    typeAddress={TypeAddress.ORIGIN}
                                    setSelectedOrigin={(origin) => {
                                      const newOrigin = {
                                        ...origin,
                                        typeAddress: TypeAddress.ORIGIN
                                      };                                    
                                      setSelectedOrigin(newOrigin);                                   
                                    
                                      if (destinyAddressService?.location) {
                                        setTimeout(() => {
                                          calculateRoute(newOrigin, destinyAddressService, arrScales);
                                        }, 100);
                                      }
                                    }}                                                                
                                    disabled={isInProgress}
                                    titleAdressDestiny={titleAdressDestiny}
                                    setNameTitleDestiny={setNameTitleDestiny}
                                    titleAdressOrigin={titleAdressOrigin}
                                    setNameTitleOrigin={setNameTitleOrigin}
                                    setOnFocusAddress={setOnFocusAddress}
                                    id={"originAddress"}
                                    companie={Number(company.value) || 0}
                                    employeeAddresses={employeesSelectedFind[0]?.addresses || []}
                                    onAddressSelected={() => setErrors(prev => ({...prev, origin: false}))}
                                  />
                                  {errors.origin && (
                                    <div className="error-message fade-in">
                                      <i className="fa fa-exclamation-circle" />
                                      <span>{i18n.t("OriginError")}</span>
                                      <button 
                                        className="btn-close-error" 
                                        onClick={() => setErrors(prev => ({...prev, origin: false}))}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  )}
                                </Col>
                              )}
                              {(typeService.value === BookingType.OPEN) || (typeService.value === BookingType.LEAVING) ? null : (
                                <Col xxl={6} xl={6} xs={12} className="address-input">
                                  <PlacesServices
                                    selectedDestiny={selectedDestiny}
                                    setAddressesMarkers={setAddressesMarkers}
                                    selectedAddress={destinyAddressService}
                                    addressesMarkers={addressesMarkers}
                                    setSelectedAddress={(address) => {
                                      setDestinyAddressService(address);
                                      setErrors(prev => ({...prev, destiny: false}));
                                    }}
                                    typeAddress={TypeAddress.DESTINY}
                                    setSelectedDestiny={(destiny) => {
                                      setSelectedDestiny(destiny);
                                      validateAddresses();
                                    }}
                                    disabled={!originAddressService.description && originAddressService.dragg}
                                    titleAdressDestiny={titleAdressDestiny}
                                    setNameTitleDestiny={setNameTitleDestiny}
                                    titleAdressOrigin={titleAdressOrigin}
                                    setNameTitleOrigin={setNameTitleOrigin}
                                    setOnFocusAddress={setOnFocusAddress}
                                    id={"destinyAddress"}
                                    companie={Number(company.value) || 0}
                                    employeeAddresses={employeesSelectedFind[0]?.addresses || []}
                                    onAddressSelected={() => setErrors(prev => ({...prev, destiny: false}))}
                                  />
                                  {errors.destiny && (
                                    <div className="error-message fade-in">
                                      <i className="fa fa-exclamation-circle" />
                                      <span>{i18n.t("DestinyError")}</span>
                                      <button 
                                        className="btn-close-error" 
                                        onClick={() => setErrors(prev => ({...prev, destiny: false}))}
                                        aria-label={i18n.t("CloseError")}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  )}
                                </Col>
                              )}
                            </Row>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                  {!showEmployees && (
                    <>
                      {showNextBlock && (<hr/>)}
                      {(typeService.value === BookingType.OPEN) && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (originAddressService.description) && dropDownHidde(!showUnits, VisibilityTypes.UNITS)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("UnitsNumber")} ${ units ? `(${units})` : ''} `}
                              <i className={ `${showUnits ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectUnits", { number: 3 })}
                          </p>
                          {showUnits && (
                            <Row>
                              <Col xxl={2} md={2} xs={2}>
                              <p className="request-units-text single-line-text" htmlFor="companyInput">
                                {i18n.t("Units")}
                              </p>
                                <Input
                                  type="number"
                                  className="form-input units-input"
                                  defaultValue={units}
                                  onBlur={(e) => onBlurUnits(e.target.value)}
                                  placeholder={i18n.t("WriteUnit")}
                                  min={1}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {showNextBlock && (<hr/>)}
                    </>
                  )}
                  {(typeService.value == BookingType.CLOSED || (typeService.value === BookingType.OPEN)) && showNextBlock && ( 
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => (originAddressService.description || destinyAddressService.description) && dropDownHidde(!showEmployees, VisibilityTypes.EMPLOYEES)}
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("Employees")} ${ employeesSelectedFind.length != 0 ? `(${i18n.t("ShowMore")})` : ''} ` }
                          <i className={ `${showEmployees ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }  />
                        </h6>
                      </Link>
                      <p className={`request-create-text ${showEmployees ? 'single-line-text' : ''}`}>
                        {i18n.t("SelectEmployees", { number: 4 })}
                      </p>
                      {showAddEmployeeLink && (
                        <Link 
                          className="add-scale-text" 
                          onClick={onClickShowEmployees}
                        >
                          <i className="bx bx-plus add-employee-icon" />
                          {i18n.t("AddEmployeesToTheService")}
                        </Link>
                      )}
                      {showEmployees && (
                        <Row>
                          <hr/>
                          <Col xxl={12} xl={12} xs={12}>
                            {(!isEditing &&
                              <>
                                <Link 
                                  className="request-create-title"
                                  onClick={() => setShowEmployeesAvailable(!showEmployeesAvailable)}
                                >
                                  <h6 className="request-create-title">
                                    {i18n.t("AvailableEmployees")}
                                    <i className={ `${showEmployees ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                                  </h6>
                                </Link>
                                {!showEmployeesAvailable && !isEditing && (
                                  <div className="table-responsive">
                                    <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                                      <Col xxl={5} md={5} xs={5} className=""/>
                                      <Col xxl={7} md={7} xs={7} className="row">
                                        <Col xxl={12} md={12} xs={12} className="">
                                          <div className="row g-2">
                                            <div className="col-12 col-md-4">
                                              <div className="position-relative">
                                                <Input
                                                  type="text"
                                                  name="identifier"
                                                  className="employees-search-input"
                                                  id="identifierInput"
                                                  placeholder={i18n.t("SearchEmployeeNumber")}
                                                  value={autoformik.values.identifier}
                                                  onChange={(e) => {
                                                    autoformik.handleChange(e);
                                                    searchFilters(e.target.value, "identifier");
                                                  }}
                                                  invalid={autoformik.touched.identifier && autoformik.errors.identifier}
                                                />
                                                {autoformik.errors.identifier && autoformik.touched.identifier && (
                                                  <FormFeedback type="invalid" className="d-block">
                                                    {autoformik.errors.identifier}
                                                  </FormFeedback>
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                              <div className="position-relative">
                                                <Input
                                                  type="text"
                                                  name="search"
                                                  className="employees-search-input"
                                                  id="searchInput"
                                                  placeholder={i18n.t("SearchName")}
                                                  value={autoformik.values.search}
                                                  onChange={(e) => {
                                                    autoformik.handleChange(e);
                                                    searchFilters(e.target.value, "name");
                                                  }}
                                                  invalid={autoformik.touched.search && autoformik.errors.search}
                                                />
                                                {autoformik.errors.search && autoformik.touched.search && (
                                                  <FormFeedback type="invalid" className="d-block">
                                                    {autoformik.errors.search}
                                                  </FormFeedback>
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                              <div className="position-relative">
                                                <Input
                                                  type="text"
                                                  name="depot"
                                                  className="employees-search-input"
                                                  id="depotInput"
                                                  placeholder={i18n.t("SearchDepartment")}
                                                  value={autoformik.values.depot}
                                                  onChange={(e) => {
                                                    autoformik.handleChange(e);
                                                    searchFilters(e.target.value, "depot");
                                                  }}
                                                  invalid={autoformik.touched.depot && autoformik.errors.depot}
                                                />
                                                {autoformik.errors.depot && autoformik.touched.depot && (
                                                  <FormFeedback type="invalid" className="d-block">
                                                    {autoformik.errors.depot}
                                                  </FormFeedback>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Col>
                                    </Col>
                                    <Table className="table table-responsive">
                                      <thead>
                                        <tr>
                                          <th className="bg-light">{i18n.t("EmployeeNumber")}</th>
                                          <th className="bg-light">{i18n.t("Name")}</th>
                                          <th className="bg-light cost-center-header">{i18n.t("Department")}</th>
                                          <th className="bg-light">{i18n.t("EmployeeAddress")}</th>
                                          <th className="bg-light">{i18n.t("Services")}</th>
                                          <th className="bg-light">{i18n.t("Actions")}</th>
                                        </tr>
                                      </thead>
                                      {isLoading ? null :
                                        <tbody>
                                          {map(findEmployees, (employee, key) => (
                                            <tr key={key}>
                                              <td>{employee.identifier || "N/A"}</td>  
                                              <td>{employee.name}</td>                                          
                                              <td>{employee.depot || i18n.t("NoDepartment")}</td>
                                              <td>
                                                {employee.addresses.length > 0 ? employee.addresses[0].address.description : i18n.t("NoAddressRegistered")}
                                              </td>
                                              <td className="text-center">
                                                {employee.cost_center_id && employee.available_trips !== -1
                                                  ? employee.available_trips
                                                  : "N/A"
                                                }
                                              </td>
                                              <td>
                                                <div className="d-flex gap-3">
                                                <button
  disabled={
    (employee.cost_center_id
      ? employee.available_trips === 0
      : false) ||
    groupedEmployees.reduce((total, group) => total + group.length, 0) >= 4 * units
  }
  className="btn btn-users fs-8"
  onClick={() => 
    (!employee.cost_center_id || employee.available_trips !== 0) && onClickAddEmployees(employee)
  }
>
  {i18n.t("Add")}
</button>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      }
                                    </Table>
                                    {isLoading ? (
                                      <Spinners setLoading={setLoading} />
                                    ) : (
                                      <StyledPagination
                                        pages={employees.pages}
                                        setLoading={setLoading}
                                        token={token}
                                        viewPaginations={5}
                                        listTable={setFindEmployees}
                                        id={null}
                                        methodCustom={getEmployeesAdmin}
                                        opts={opts}
                                        page={employees.page}
                                        total={employees.total}
                                        size={employees.size}
                                        paginationDiv="col-lg-12"
                                        paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                                      />
                                    )}
                                  </div>
                                )}
                                <div className="request-separator" />
                                <Link
                                  className="add-scale-text"
                                  onClick={() => setShowAddEmployeeForm(true)}
                                >
                                  <i className="bx bx-plus add-employee-icon" />
                                  {i18n.t("AddUnregisteredEmployee")}
                                </Link>
                                {showAddEmployeeForm && (
                                  <div className="mt-3">
                                    <Row className="align-items-center">
                                      <Col md={6}>
                                        <Label htmlFor="employeeName" className="fw-bold">
                                          {i18n.t("Name")}
                                        </Label>
                                        <Input
                                          type="text"
                                          id="employeeName"
                                          placeholder={i18n.t("EmployeeName")}
                                          className="form-control"
                                          value={unregisteredEmployee.name}
                                          onChange={(e) =>
                                            setUnregisteredEmployee({ ...unregisteredEmployee, name: e.target.value })
                                          }
                                        />
                                      </Col>
                                      <Col md={6}>
                                        <Label htmlFor="employeeDepot" className="fw-bold">
                                          {i18n.t("Department")}
                                        </Label>
                                        <Input
                                          type="text"
                                          id="employeeDepot"
                                          placeholder={i18n.t("EmployeeDepartment")}
                                          className="form-control"
                                          value={unregisteredEmployee.depot}
                                          onChange={(e) =>
                                            setUnregisteredEmployee({ ...unregisteredEmployee, depot: e.target.value })
                                          }
                                        />
                                      </Col>
                                    </Row>
                                    <div className="row pt-3">
                                      <div className="col-2">
                                        <button
                                          className="btn btn-add-employees"
                                          onClick={handleAddUnregisteredEmployee}
                                        >
                                          {i18n.t("Add")}
                                        </button>
                                      </div>
                                      <div className="col-2 text-end button-margin-unregistered-employee">
                                        <button
                                          className="btn btn-go-back border"
                                          onClick={handleCancelAddEmployee}
                                        >
                                          {i18n.t("Cancel")}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="request-separator" />
                              </>
                            )}
                          </Col>
                          <Col xxl={12} md={12} xs={12}>
                          {(!isEditing &&
                            <>
                              {groupedEmployees.slice(0, units).map((group, index) => (
                                <div key={index}>
                                  <h6
                                    className="request-create-title"
                                    onClick={() => toggleTableVisibility(index)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {i18n.t("SelectedEmployees")} {`(${i18n.t("Unit")} ${index + 1} - ${i18n.t("Employees")} ${group.length}/4)`}
                                    <i
                                      className={`${visibleTables[index] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon`}
                                    />
                                  </h6>
                                  {visibleTables[index] && (
                                    <div className="table-responsive pt-3">
                                      <Table className="table table-responsive">
                                        <thead>
                                          <tr>
                                            <th className="bg-light">{i18n.t("EmployeeNumber")}</th>
                                            <th className="bg-light">{i18n.t("Name")}</th>
                                            <th className="bg-light cost-center-header">{i18n.t("Department")}</th>
                                            <th className="bg-light">{i18n.t("EmployeeAddress")}</th>
                                            <th className="bg-light">{i18n.t("Services")}</th>
                                            <th className="bg-light">{i18n.t("Actions")}</th>
                                          </tr>
                                        </thead>
                                        {isLoading ? null : (
                                          <tbody>
                                            {map(group, (employee, key) => (
                                              <tr key={key}>
                                                <td>{employee.identifier || "N/A"}</td>
                                                <td>{employee.name}</td>
                                                <td>{employee.depot || i18n.t("NoDepartment")}</td>
                                                <td>
                                                {employee.selectedAddress?.address?.description || 
                                                  (employee.addresses.length > 0 ? employee.addresses[0].address.description : i18n.t("NoAddressRegistered"))}
                                                </td>
                                                <td className="text-center">
                                                  {employee.available_trips === -1 || !employee.available_trips ? "N/A" : employee.available_trips}
                                                </td>
                                                <td>
                                                  <div className="d-flex gap-3">
                                                    <button
                                                      disabled={
                                                        (employee.cost_center_id ? employee.available_trips === 0 : false) || 
                                                        (employee.idEmployee === autoAddedEmployeeId)
                                                      }
                                                      className="btn btn-link text-green p-0"
                                                      onClick={enterEditMode}
                                                    >
                                                      <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                      <UncontrolledTooltip placement="top" target="edittooltip">
                                                        {i18n.t("Edit")}
                                                      </UncontrolledTooltip>
                                                    </button>
                                                    <button
                                                      disabled={
                                                        (employee.cost_center_id ? employee.available_trips === 0 : false) || 
                                                        (employee.idEmployee === autoAddedEmployeeId)
                                                      }
                                                      className="btn btn-link text-danger p-0"
                                                      onClick={() => onClickRemoveEmployee(employee)}
                                                    >
                                                      <i className="mdi mdi-delete font-size-18" id="removetooltip" />
                                                      <UncontrolledTooltip placement="top" target="removetooltip">
                                                        {i18n.t("Remove")}
                                                      </UncontrolledTooltip>
                                                    </button>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        )}
                                      </Table>
                                      {index === getLastVisibleTableIndex() && index < units - 1 && (
                                        <Link 
                                          className="add-scale-text mt-3 d-block"
                                          onClick={() => {}}
                                        >
                                          <i className="bx bx-check-circle add-employee-icon" />
                                          {i18n.t("ContinueToNextUnit")}
                                        </Link>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ))}
                              <div className="row pt-3">
                                <div className="col-6 col-sm-2 mb-2 mb-sm-0">
                                  <button
                                    className="btn btn-add-employees w-100"
                                    disabled={employeesSelectedFind.length === 0}
                                    onClick={() => onClickAccept()}
                                  >
                                    {i18n.t("AddEmployees")}
                                  </button>
                                </div>
                                <div className="col-6 col-sm-2">
                                  <button 
                                    className="btn btn-go-back border w-100" 
                                    onClick={() => onClickCancel()}
                                  >
                                    {i18n.t("Cancel")}
                                  </button>
                                </div>
                              </div>
                              </>
                            )}             
                          </Col>
                          {isEditing && (
                            <div className="mt-4 d-flex flex-row-reverse">
                              <div className="w-50 ps-3">
                                <MapServices
                                  titleAdressArrScales={titleAdressArrScales}
                                  titleAdressArrEmployees={titleAdressArrEmployees}
                                  setNameTitleDestiny={setNameTitleDestiny}
                                  titleAdressDestiny={titleAdressDestiny}
                                  setNameTitleArrScales={setNameTitleArrScales}
                                  setNameTitleEmployees={setNameTitleEmployees}
                                  titleAdressOrigin={titleAdressOrigin}
                                  setNameTitleOrigin={setNameTitleOrigin}
                                  selectedDestiny={selectedDestiny}
                                  selectedOrigin={selectedOrigin}
                                  setShowUnits={setShowUnits}
                                  setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                                  servicesView={true}
                                  setShowAddresses={setShowAddresses}
                                  showAddresses={showAddresses}
                                  setAddressesMarkers={setAddressesMarkers}
                                  addressesMarkers={addressesMarkers}
                                  selectedAddress={destinyAddressService}
                                  setFindEmployees={setFindEmployees}
                                  findEmployees={findEmployees}
                                  setShowEmployees={setShowEmployees}
                                  typeService={typeService}
                                  setArrScales={setArrScales}
                                  arrScales={arrScales}
                                  setSelectedAddress={setDestinyAddressService}
                                  selectedAddressOrigin={originAddressService}
                                  setSelectedAddressOrigin={setOriginAddressService}
                                  selectedAddressDestiny={destinyAddressService}
                                  setSelectedAddressDestiny={setDestinyAddressService}
                                  typeAddress={onFocusAddress}
                                  setOnFocusAddress={setOnFocusAddress}
                                  setSelectedDestiny={setSelectedDestiny}
                                  setSelectedOrigin={setSelectedOrigin}
                                  disabled={false}
                                />
                              </div>
                              <div className="w-50">
                                <h6 className="request-create-title">
                                  {i18n.t("SelectedEmployees")}
                                  <button 
                                    className="btn btn-link float-end"
                                    onClick={() => {
                                      setIsEditing(false);
                                      setEditingEmployee(null);
                                    }}
                                  >
                                    <i className="fa fa-chevron-up chevron-icon" />
                                  </button>
                                </h6>
                                <p>{i18n.t("EmployeesAddressing")}</p>
                                <div className="table-responsive pt-3">
                                  <Table className="table table-responsive">
                                    <thead>
                                      <tr>
                                        <th className="bg-light">{i18n.t("Name")}</th>
                                        <th className="bg-light">{i18n.t("EmployeeAddress")}</th>
                                        <th className="bg-light">{i18n.t("Services")}</th>
                                        <th className="bg-light">{i18n.t("Actions")}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {groupedEmployees.flat().map((employee, index) => (
                                        <tr key={index}>
                                          <td>{employee.name}</td>
                                          <td>
                                            {editingAddressForEmployee[employee.id] ? (
                                              <Places
                                                selected={null}
                                                setSelected={() => {}}
                                                setHiddenOne={() => {}}
                                                disabled={false}
                                                id={`employee-address-${employee.id}`}
                                                placeholder={i18n.t("WriteAddress")}
                                                setTitleAdress={() => {}}
                                                typeAddress="predefined"
                                                selectedAddress={tempAddress[employee.id] || employee.selectedAddress?.address || { description: "", location: null }}
                                                setSelectedAddress={(newAddress) => {
                                                  setTempAddress(prev => ({
                                                    ...prev,
                                                    [employee.id]: newAddress
                                                  }));
                                                  setNewAddress(newAddress);
                                                  setSelectedEmployeeId(employee.idEmployee);
                                                  
                                                  handleEmployeeEdit(
                                                    editingEmployees.findIndex(e => e.id === employee.id), 
                                                    "selectedAddress", 
                                                    { 
                                                      id: "temp-" + Date.now(),
                                                      address: newAddress 
                                                    }
                                                  );
                                                }}
                                                setRowsScale={() => {}}
                                                rowsScale={[]}
                                                addressRow={null}
                                                setHiddenSecond={() => {}}
                                                servicesView={false}
                                                editAddress={true}
                                              />
                                            ) : employee.addresses?.length > 1 ? (
                                              <Select
                                                name="employeeAddress"
                                                placeholder={i18n.t("SelectAddress")}
                                                value={employee.addresses
                                                  .map(addr => ({
                                                    value: addr.id,
                                                    label: addr.address.description
                                                  }))
                                                  .find(option => option.value === (temporarySelections[employee.id]?.id || employee.selectedAddress?.id || employee.addresses[0]?.id))
                                                }
                                                options={employee.addresses.map(addr => ({
                                                  value: addr.id,
                                                  label: addr.address.description
                                                }))}
                                                className="select2-selection"
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  menu: (base) => ({ ...base, zIndex: 9999 }),
                                                  option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected
                                                      ? '#596DDE'
                                                      : state.isFocused
                                                      ? '#F2F2F2'
                                                      : 'white',
                                                    color: state.isSelected ? 'white' : 'black',
                                                    cursor: 'pointer',
                                                  }),
                                                }}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                onChange={(selectedOption) => {
                                                  if (!selectedOption) return;
                                                  
                                                  const selectedAddr = employee.addresses.find(
                                                    addr => addr.id === selectedOption.value
                                                  );
                                              
                                                  if (selectedAddr) {
                                                    setTemporarySelections(prev => ({
                                                      ...prev,
                                                      [employee.id]: selectedAddr
                                                    }));
                                              
                                                    handleEmployeeEdit(index, "selectedAddress", selectedAddr);
                                                    updateEmployeeScale(employee.idEmployee, selectedAddr.address);
                                                  }
                                                }}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                              />
                                            ) : employee.addresses?.length === 1 ? (
                                              employee.addresses[0].address.description
                                            ) : (
                                              i18n.t("NoAddressRegistered")
                                            )}
                                          </td>
                                          <td className="text-center">{employee.available_trips || "N/A"}</td>
                                          <td>
                                            {editingAddressForEmployee[employee.id] ? (
                                              <div className="d-flex gap-3">
                                                <button
                                                  className="btn btn-add-employees"
                                                  onClick={async () => {
                                                    if (newAddress && selectedEmployeeId) {
                                                      try {
                                                        if (!newAddress.description || !newAddress.location) {
                                                          console.error("Incomplete address", newAddress);
                                                          return;
                                                        }

                                                        const payload = {
                                                          addresses: [
                                                            {
                                                              name: "Dirección Adicional",
                                                              address: {
                                                                location: {
                                                                  lat: newAddress.location.lat,
                                                                  lon: newAddress.location.lon
                                                                },
                                                                description: newAddress.description
                                                              }
                                                            }
                                                          ]
                                                        };

                                                        const response = await postEmployeesAdminCreateAddress(
                                                          token,
                                                          selectedEmployeeId,
                                                          payload
                                                        );

                                                        const updatedEmployees = editingEmployees.map(emp => {
                                                          if (emp.idEmployee === selectedEmployeeId) {
                                                            const newAddressEntry = {
                                                              id: response.id,
                                                              address: {
                                                                description: newAddress.description,
                                                                location: {
                                                                  lat: newAddress.location.lat,
                                                                  lon: newAddress.location.lon
                                                                }
                                                              },
                                                            };
                                                            
                                                            return {
                                                              ...emp,
                                                              addresses: [...(emp.addresses || []), newAddressEntry],
                                                              selectedAddress: newAddressEntry
                                                            };
                                                          }
                                                          return emp;
                                                        });

                                                        setEditingEmployees(updatedEmployees);
                                                        
                                                        const updatedMainEmployees = groupedEmployees.flat().map(emp => {
                                                          if (emp.idEmployee === selectedEmployeeId) {
                                                            return updatedEmployees.find(e => e.idEmployee === selectedEmployeeId) || emp;
                                                          }
                                                          return emp;
                                                        });
                                                        
                                                        setEmployeesSelectedFind(updatedMainEmployees);
                                                        setEditingAddressForEmployee(prev => ({
                                                          ...prev,
                                                          [employee.id]: false
                                                        }));
                                                        setNewAddress(null);
                                                        setSelectedEmployeeId(null);
                                                        setTempAddress(prev => {
                                                          const newTemp = {...prev};
                                                          delete newTemp[employee.id];
                                                          return newTemp;
                                                        });

                                                      } catch (error) {
                                                        console.error("Error saving:", error);
                                                        setErrorAlert(true);
                                                        setErrorAlertMessage(error.response?.data?.detail || error.message);
                                                      }
                                                    } else {
                                                      console.warn("No address or employee selected", {
                                                        newAddress,
                                                        selectedEmployeeId,
                                                      });
                                                    }
                                                  }}
                                                  disabled={!newAddress?.description}
                                                >
                                                  {i18n.t("Save")}
                                                </button>
                                            </div>
                                            ) : (
                                              <div className="d-flex gap-3">
                                                <button
                                                  className="btn btn-link text-danger p-0"
                                                  onClick={() => onClickRemoveEmployee(employee)}
                                                  disabled={employee.idEmployee === autoAddedEmployeeId}
                                                >
                                                  <i className="mdi mdi-delete font-size-18" id="removetooltip" />
                                                  <UncontrolledTooltip placement="top" target="removetooltip">
                                                    {i18n.t("Remove")}
                                                  </UncontrolledTooltip>
                                                </button>
                                                <button
                                                  className="btn btn-link text-success p-0"
                                                  onClick={() => {
                                                    if (employee.idEmployee !== autoAddedEmployeeId) {
                                                      setEditingAddressForEmployee(prev => ({
                                                        ...prev,
                                                        [employee.id]: true
                                                      }));
                                                    }
                                                  }}
                                                  disabled={employee.idEmployee === autoAddedEmployeeId}
                                                >
                                                  <i className="mdi mdi-plus-circle font-size-18" id="addaddresstooltip" />
                                                  <UncontrolledTooltip placement="top" target="addaddresstooltip">
                                                    {i18n.t("Add")}
                                                  </UncontrolledTooltip>
                                                </button>                                      
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                  <div className="row pt-3 text-center">
                                    <div className="col-2">
                                      <button
                                        className="btn btn-users"
                                        onClick={handleSave}
                                      >
                                        {i18n.t("Save")}
                                      </button>
                                    </div>
                                    <div className="col-2">
                                      <button 
                                        className="btn btn-go-back" 
                                        onClick={() => setIsEditing(false)}
                                      >
                                        {i18n.t("Cancel")}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Row>
                      )}
                    </Col>
                  )}
                  {showNextBlock && (<hr/>)}
                  {(!showEmployees && typeService.value === BookingType.CLOSED) && showNextBlock && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showScales, VisibilityTypes.SCALES)}
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("Scales")} ${arrScales[0]?.description ? `(${arrScales.length})` : '' } ` }
                          <i className={ `${showScales ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="scalesInput">{i18n.t("AddedScalesEmployees")}</p>
                      {showScales && (
                        <Col xxl={12} md={12} xs={12}>
                          {[...arrScales]
                            .sort((a, b) => {
                              const aHasDesc = !!a.description;
                              const bHasDesc = !!b.description;
                              return aHasDesc === bHasDesc ? 0 : aHasDesc ? -1 : 1;
                            })
                            .map((formRow, key) => (
                              <Row key={formRow.id ?? key} className="align-items-start mb-3">
                                <Col xxl={10} md={10} xs={12}>
                                  <Label htmlFor="scaleAddressInput" className="form-label">
                                    {i18n.t("Scale") + " " + (key + 1)}
                                    {formRow.employeeId && (
                                      <span className="badge bg-info ms-2">
                                        {i18n.t("EmployeeScale")}
                                      </span>
                                    )}
                                  </Label>
                                  <PlacesServices
                                    selectedDestiny={selectedDestiny}
                                    setAddressesMarkers={setAddressesMarkers}
                                    selectedAddress={formRow}
                                    addressesMarkers={addressesMarkers}
                                    setSelectedAddress={(newAddress) => {
                                      const updatedScales = [...arrScales];
                                      if (!formRow.employeeId) {
                                        const index = updatedScales.findIndex(s => s.id === formRow.id);
                                        if (index !== -1) {
                                          updatedScales[index] = {
                                            ...updatedScales[index],
                                            ...newAddress,
                                          };
                                        }
                                      } else {
                                        let emptyIndex = updatedScales.findIndex(s => !s.description);
                                        if (emptyIndex === -1) {
                                          emptyIndex = updatedScales.length;
                                          updatedScales.push({
                                            id: Date.now(),
                                            typeAddress: TypeAddress.ARRAY_SCALES,
                                            name: "",
                                          });
                                        }
                                        updatedScales[emptyIndex] = {
                                          ...updatedScales[emptyIndex],
                                          ...newAddress,
                                          employeeId: formRow.employeeId,
                                          employeeName: formRow.employeeName,
                                          typeAddress: TypeAddress.ARRAY_SCALES,
                                        };
                                      }
                                      setArrScales(updatedScales);
                                      setAddressesMarkers(prev => [
                                        ...prev.filter(m =>
                                          !(m.employeeId === formRow.employeeId && m.typeAddress === TypeAddress.ARRAY_SCALES)
                                        ),
                                        {
                                          id: `arrayScales-${formRow.id}`,
                                          description: newAddress.description,
                                          location: {
                                            lat: newAddress.location.lat,
                                            lng: newAddress.location.lon || newAddress.location.lng,
                                          },
                                          typeAddress: TypeAddress.ARRAY_SCALES,
                                          dragg: false,
                                          employeeId: formRow.employeeId,
                                          employeeName: formRow.employeeName,
                                        },
                                      ]);
                                      if (selectedOrigin && selectedDestiny) {
                                        setTimeout(() => {
                                          calculateRoute(selectedOrigin, selectedDestiny, updatedScales);
                                        }, 100);
                                      }
                                    }}
                                    typeAddress={TypeAddress.ARRAY_SCALES}
                                    setSelectedDestiny={setSelectedDestiny}
                                    rowsData={arrScales}
                                    setRowsScale={setArrScales}
                                    rowsIndex={formRow}
                                    titleAdressDestiny={titleAdressDestiny}
                                    setNameTitleDestiny={setNameTitleDestiny}
                                    titleAdressOrigin={titleAdressOrigin}
                                    setNameTitleOrigin={setNameTitleOrigin}
                                    setOnFocusAddress={setOnFocusAddress}
                                    setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                                    id={`arrayScales-${formRow.id}`}
                                  />
                                </Col>
                                {formRow.description && !formRow.employeeId && (
                                  <div className="d-flex justify-content-md-start justify-content-center mt-2">
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => handleRemoveRowScale(formRow.id)}
                                    >
                                      {i18n.t("DeleteScale")}
                                    </button>
                                  </div>
                                )}
                              </Row>
                            ))}                         
                          <Link
                            className="add-scale-text"
                            onClick={handleAddRowScale}
                          >
                            <i className="bx bx-plus add-scale-icon add-employee-icon" />
                            {i18n.t("AddScale")}
                          </Link>
                        </Col>
                      )}
                    </Col>
                  )}
                  {!showEmployees && (
                    <>
                      {showNextBlock && <hr />}
                      {(isPartnerAllowed(company.value || infoUser?.partner_id) && showNextBlock && (
                        <>
                          <Col xxl={12} md={12} xs={12}>
                            <Link
                              className="request-create-title"
                              onClick={() => (originAddressService.description) && dropDownHidde(!showIdTag, VisibilityTypes.IDTAG)}
                            >
                              <h6 className="request-create-title">
                                {i18n.t("IdTag")}
                                <i className={`${showIdTag ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon`} />
                              </h6>
                            </Link>
                            <p className="request-create-text" htmlFor="companyInput">
                              {i18n.t("AddIdTag")}
                            </p>
                            {showIdTag && (
                              <Row>
                                <Col xxl={12} md={12} xs={12}>
                                  <Label>{i18n.t("IdTagLabel")}</Label>
                                  <Input
                                    type="textarea"
                                    value={idTag}
                                    placeholder={i18n.t("IdTagPlaceholder")}
                                    onChange={(e) => setIdTag(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <hr />
                        </>
                      ))}
                    </>
                  )}
                </Col>
                {!showEmployees && (
                  <Col xxl={6} md={6} xs={12}>
                    <MapServices
                      key={key}
                      titleAdressArrScales={titleAdressArrScales}
                      titleAdressArrEmployees={titleAdressArrEmployees}
                      setNameTitleDestiny={setNameTitleDestiny}
                      titleAdressDestiny={titleAdressDestiny}
                      setNameTitleArrScales={setNameTitleArrScales}
                      setNameTitleEmployees={setNameTitleEmployees}
                      titleAdressOrigin={titleAdressOrigin}
                      setNameTitleOrigin={setNameTitleOrigin}
                      selectedDestiny={selectedDestiny}
                      selectedOrigin={selectedOrigin}
                      setShowUnits={setShowUnits}
                      setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                      servicesView={true}
                      setShowAddresses={setShowAddresses}
                      showAddresses={showAddresses}
                      setAddressesMarkers={setAddressesMarkers}
                      addressesMarkers={addressesMarkers}
                      selectedAddress={destinyAddressService}
                      setFindEmployees={setFindEmployees}
                      findEmployees={findEmployees}
                      setShowEmployees={setShowEmployees}
                      typeService={typeService}
                      setArrScales={setArrScales}
                      arrScales={arrScales}
                      setSelectedAddress={setDestinyAddressService}
                      selectedAddressOrigin={originAddressService}
                      setSelectedAddressOrigin={setOriginAddressService}
                      selectedAddressDestiny={destinyAddressService}
                      setSelectedAddressDestiny={setDestinyAddressService}
                      typeAddress={onFocusAddress}
                      setOnFocusAddress={setOnFocusAddress}
                      setSelectedDestiny={setSelectedDestiny}
                      setSelectedOrigin={setSelectedOrigin}
                      disabled={false}
                    />
                  </Col>
                )}
                {!showEmployees && (
                  <Col xxl={12} xl={12} xs={12} className="pt-2 d-flex">
                    <button
                      onClick={() => (isEditMode ? onClickUpdateRequest() : onClickCreateRequest())} 
                      className="btn btn-request"
                      disabled={isDisabled || isSubmitting}
                    >
                      {i18n.t(isEditMode ? "Update" : "RequestService")}
                    </button>
                    <Link to={"/services/request"} className="btn btn-go-back mx-2">
                      {i18n.t("GoBack")}
                    </Link>
                  </Col>
                )}
              </Row>
            </Card>
          </div>
        </div>
        <AlertError showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={i18n.t("ServiceAlertError")}
          textBody={errorAlertMessage}
        />
        <EmployeeScalePopup
          isOpen={showScaleModal}
          toggle={handleScaleModalCancel}
          employee={pendingEmployee}
          onConfirm={handleScaleModalResponse}
          onCancel={handleScaleModalCancel}
        />
      </div>
    </Fragment>
  );
};

export default RequestService;
